import React from "react";
import "./SessionLoading.css";

/**
 * Full-viewport session bootstrap loading state.
 */
const SessionLoading = ({
  title = "Oturum hazırlanıyor",
  subtitle = "Güvenli bağlantı kontrol ediliyor",
}) => (
  <div className="session-loading" role="status" aria-live="polite" aria-busy="true">
    <div className="session-loading__card">
      <div className="session-loading__spinner" aria-hidden="true">
        <span className="session-loading__ring" />
        <span className="session-loading__ring session-loading__ring--soft" />
        <span className="session-loading__core" />
      </div>

      <div className="session-loading__copy">
        <p className="session-loading__title">{title}</p>
        {subtitle ? <p className="session-loading__subtitle">{subtitle}</p> : null}
      </div>

      <div className="session-loading__track" aria-hidden="true">
        <div className="session-loading__bar" />
      </div>
    </div>
  </div>
);

export default SessionLoading;
